<template>
  <div id="table1">
    <div class="title">
      <i class="iconfont icon-exe-sale-primary"
         style="color: aqua; font-size: 15px; margin-right: 5px"></i>
      <span style="font-size: 18px; font-weight: 'bold'">{{ title }}</span><dv-decoration-1 style="width: 100px; height: 20px" />
    </div>
    <dv-scroll-board v-if="config.data.length !== 0"
                     :config="config"
                     ref="scrollBoard"
                     @mouseover.native="handleMouseOver"
                     @mouseleave.native="handleMouseLeave"
                     style="width: 100%; height: 50%; font-size: 12px"
                     @click="handleToList" />
    <el-divider v-if="config.data.length !== 0"></el-divider>
    <dv-scroll-board
                     :config="config2"
                     ref="scrollBoard"
                     @mouseover.native="handleMouseOver"
                     @mouseleave.native="handleMouseLeave"
                     style="width: 100%; height: 50%; font-size: 12px"
                     @click="handleToList" />
    <el-tooltip v-model="tooltipVisible"
                placement="right"
                :popper-options="{ positionFixed: true }"
                effect="light"
                :manual="true">
      <div ref="tooltipAnchor2"
           style="position: absolute; pointer-events: none; opacity: 0"></div>
      <div slot="content" v-html="tooltipContent"></div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      config: {
        header: [
          '预警类型',
          '最新预警时间',
          '预警次数'
        ],
        data: [],
        hoverPause: true, // 鼠标悬浮时暂停轮播
        rowNum: 3, // 表格行数
        headerHeight: 35, // 表头高度
        headerBGC: '#0f1325', // 表头背景颜色
        oddRowBGC: '#0f1325', // 奇数行背景颜色
        evenRowBGC: '#171c33', // 偶数行背景颜色
        // index: true, // 是否开启序号
        // indexHeader: '序号', // 序号名称
        // columnWidth: ['50'], // 表头宽度Array[x,x,x,x]
        waitTime: 6000, // 翻页时间
        carousel: 'page', // 滚动类型page为整页，默认为单条
        align: ['center', 'center', 'center', 'center', 'center'] // 对齐方式Array[x,x,x,x]
      },
      config2: {
        header: [],
        data: [],
        rowNum: 3, // 表格行数
        headerHeight: 35, // 表头高度
        headerBGC: '#0f1325', // 表头背景颜色
        oddRowBGC: '#0f1325', // 奇数行背景颜色
        evenRowBGC: '#171c33', // 偶数行背景颜色
        waitTime: 6000, // 翻页时间
        carousel: 'page', // 滚动类型page为整页，默认为单条
        align: ['center', 'center', 'center', 'center', 'center'] // 对齐方式Array[x,x,x,x]
      },
      tooltipVisible: false,
      tooltipContent: '',
      currentCell: null,
      isShow: false
    }
  },
  created () { },
  mounted () {
    const tempArr = this.tableData.map((item) => {
      // const { reservoirAreaName, forewarningType, reasonType, forewarningTime, forewarningCout } = item
      const { forewarningType, forewarningTime, forewarningCout } = item
      return [forewarningType, forewarningTime, forewarningCout]
    })
    // 分出未处理、已处理的预警数据
    let data1 = []
    let data2 = []
    for (let i = 0; i < tempArr.length; i++) {
      var type = tempArr[i][0]
      if (type.indexOf('未处理') === 1) {
        data1.push(tempArr[i])
      } else {
        data2.push(tempArr[i])
      }
    }
    this.config.data = data1
    this.config2.data = data2
    this.config2.header = !this.config.data.length ? ['预警类型', '最新预警时间', '预警次数'] : []
    window.addEventListener('resize', () => {
      this.$refs['scrollBoard'].updateRows()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.$refs['scrollBoard'].updateRows()
    })
  },
  methods: {
    handleToList () {
      if (this.$route.path.includes('/lfd')) {
        this.$router.push({ path: '/lfd/warehouseManager/warningLedger' })
      }
      if (this.$route.path.includes('/flk')) {
        this.$router.push({ path: '/flk/warehouseManager/warningLedger' })
      }
    },
    handleMouseOver (event) {
      this.tooltipVisible = false
      // 找到鼠标所在的单元格
      const cell = event.target.closest('.dv-scroll-board .row-item .ceil')
      if (!cell) {
        return
      }
      // 预警类型 forewarningType
      const typeVal = cell.parentNode && cell.parentNode.children[0].innerText
      if (typeVal) {
        let count = 0
        for (let i = 0; i < this.config.data.length; i++) {
          if (this.config.data[i][0] === typeVal) {
            count = i
          }
        }
        for (let i = 0; i < this.config2.data.length; i++) {
          if (this.config2.data[i][0] === typeVal) {
            count = i
          }
        }
        if (this.config.data.length > 0 && typeVal.indexOf('未处理') === -1) {
          count += 3
        }
        const rowData = this.tableData.find(
          (item) => item.forewarningType === typeVal
        )
        this.tooltipContent = '预警详情：<br/>'
        rowData.forewarningDetailShows.forEach((item) => {
          if (item.reasonType === null) {
            item.reasonType = '未处理'
          }
          this.tooltipContent += item.reasonType + ':&nbsp;&nbsp;&nbsp;' + item.count + '<br/>'
        })
        this.currentCell = cell
        // 更新 tooltip 位置
        this.$nextTick(() => {
          try {
            const rect = cell.getBoundingClientRect()
            this.$refs.tooltipAnchor2.style.top = `${rect.height * count + 100}px`
            this.$refs.tooltipAnchor2.style.left = `${rect.left - 100}px`
            this.tooltipVisible = true
          } catch (error) {
            console.error('更新tooltip位置出错:', error)
          }
        })
      }
    },
    handleMouseLeave () {
      this.tooltipVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
// 滚动表格单元格样式
::v-deep .dv-scroll-board .rows .ceil {
  font-size: 13px !important;
  transition: all 0.3s ease;
  border-radius: 4px;
  padding: 4px 8px;
}

// 行悬停效果
::v-deep .dv-scroll-board .row-item:hover {
  background-color: rgba(6, 241, 239, 0.15) !important;
  transform: translateX(5px);
  box-shadow: 0 2px 8px rgba(6, 241, 239, 0.3);
  transition: all 0.3s ease;
}

// 单元格悬停效果
::v-deep .dv-scroll-board .row-item:hover .ceil {
  color: #06f1ef !important;
  font-weight: 500;
  background-color: rgba(6, 241, 239, 0.1);
  box-shadow: inset 0 0 8px rgba(6, 241, 239, 0.2);
}

// 表头样式
::v-deep .dv-scroll-board .header {
  background-color: rgba(6, 241, 239, 0.1) !important;
  border-bottom: 2px solid #06f1ef;
}

// 表头单元格样式
::v-deep .dv-scroll-board .header .ceil {
  font-weight: bold !important;
  color: #06f1ef !important;
  font-size: 14px !important;
}

#table1 {
  width: 100%;
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: #c3cbde;
      font-size: 15px;
      margin-right: 10px;
      text-shadow: 0 0 8px rgba(6, 241, 239, 0.5);
    }
  }
  .no-data {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.5);
  }
}

// 优化分割线样式
::v-deep .el-divider {
  background-color: rgba(6, 241, 239, 0.2);
  margin: 15px 0;
}
</style>
